import lunbo from './Interface/lunbo'
import product from './Interface/product'
import dynamic from './Interface/dynamic'
import message from './Interface/message'
import news from './Interface/news'

const API = {
  lunbo,
  product,
  dynamic,
  message,
  news
}
export default API



// WEBPACK FOOTER //
// ./src/api/index.js